import { c as _c } from "react/compiler-runtime";
import { CarouselDots } from "@website/ui/carousel/carousel-dots";
import { CarouselNavigation } from "@website/ui/carousel/carousel-navigation";
import { CarouselPropertiesType } from "@website/ui/carousel/carousel.types";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { FC, useState } from "react";
export const CarouselV2: FC<CarouselPropertiesType> = t0 => {
  const $ = _c(30);
  const {
    sectionClassName: t1,
    options,
    list,
    keyCarousel,
    hasNavigation: t2,
    itemClass,
    hasDots,
    mode,
    rightBtnClassName,
    leftBtnClassName,
    disableArrowKeys,
    dotsNewDesign: t3
  } = t0;
  const sectionClassName = t1 === undefined ? "" : t1;
  const hasNavigation = t2 === undefined ? true : t2;
  const dotsNewDesign = t3 === undefined ? false : t3;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  let t4;
  if ($[0] !== mode || $[1] !== options) {
    t4 = {
      initial: 0,
      rtl: true,
      renderMode: "performance",
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      ...options,
      mode
    };
    $[0] = mode;
    $[1] = options;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [sliderReference, instanceReference] = useKeenSlider(t4);
  const t5 = `keen-slider size-full ${sectionClassName}`;
  let t6;
  if ($[3] !== itemClass || $[4] !== keyCarousel || $[5] !== list) {
    t6 = list?.map((component, index) => <article className={`keen-slider__slide ${itemClass} !overflow-visible`} key={`${keyCarousel}-slide-${index++}`}>{component}</article>);
    $[3] = itemClass;
    $[4] = keyCarousel;
    $[5] = list;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== sliderReference || $[8] !== t5 || $[9] !== t6) {
    t7 = <section className={t5} ref={sliderReference}>{t6}</section>;
    $[7] = sliderReference;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== currentSlide || $[12] !== disableArrowKeys || $[13] !== hasNavigation || $[14] !== instanceReference || $[15] !== leftBtnClassName || $[16] !== loaded || $[17] !== rightBtnClassName) {
    t8 = Boolean(hasNavigation) && loaded && instanceReference?.current && <CarouselNavigation currentReference={instanceReference.current} currentSlide={currentSlide} disableArrowKeys={disableArrowKeys} hasNavigation={hasNavigation} leftBtnClassName={leftBtnClassName} rightBtnClassName={rightBtnClassName} />;
    $[11] = currentSlide;
    $[12] = disableArrowKeys;
    $[13] = hasNavigation;
    $[14] = instanceReference;
    $[15] = leftBtnClassName;
    $[16] = loaded;
    $[17] = rightBtnClassName;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== currentSlide || $[20] !== dotsNewDesign || $[21] !== hasDots || $[22] !== instanceReference || $[23] !== keyCarousel || $[24] !== loaded) {
    t9 = Boolean(hasDots) && loaded && instanceReference?.current && <CarouselDots newDesign={dotsNewDesign} currentReference={instanceReference.current} currentSlide={currentSlide} keyCarousel={keyCarousel} />;
    $[19] = currentSlide;
    $[20] = dotsNewDesign;
    $[21] = hasDots;
    $[22] = instanceReference;
    $[23] = keyCarousel;
    $[24] = loaded;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = <article className="group relative size-full">{t7}{t8}{t9}</article>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};